import '../styles/style.less';
$ = jQuery;
